// extracted by mini-css-extract-plugin
module.exports = {"gw-tile-footer__generic":"generic-tile-hashed__gw-tile-footer__generic__2bF8i","gw-tile-header__generic":"generic-tile-hashed__gw-tile-header__generic__2SUqR"};